import { useClient, useTheme as useTheme$1 } from '@livepeer/core-react/context';
import { createControllerStore } from 'livepeer/media';
import { getDeviceInfo, addEventListeners } from 'livepeer/media/browser';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';
import { useStore } from 'zustand';
import { createStorage } from 'livepeer';
import { createTheme } from 'livepeer/media/browser/styling';

var ThemeContext = /*#__PURE__*/React.createContext(null);

var MediaControllerContext = /*#__PURE__*/React.createContext(createControllerStore({
  element: null,
  device: getDeviceInfo(),
  storage: createStorage({}),
  playerProps: {},
  opts: {}
}));

var MediaControllerProvider = function MediaControllerProvider(_ref) {
  var element = _ref.element,
    children = _ref.children,
    playerProps = _ref.playerProps,
    opts = _ref.opts;
  var mediaController = useMediaControllerStore(element, opts, playerProps);
  return /*#__PURE__*/jsx(MediaControllerContext.Provider, {
    value: mediaController,
    children: children
  });
};
var useMediaControllerStore = function useMediaControllerStore(element, opts, playerProps) {
  var client = useClient();
  var store = React.useMemo(function () {
    return createControllerStore({
      element: element !== null && element !== void 0 ? element : null,
      device: getDeviceInfo(),
      storage: client.storage,
      opts: opts,
      playerProps: playerProps
    });
  }, [element, client === null || client === void 0 ? void 0 : client.storage, opts, playerProps]);
  React.useEffect(function () {
    var _addEventListeners = addEventListeners(store, opts),
      destroy = _addEventListeners.destroy;
    return function () {
      destroy === null || destroy === void 0 ? void 0 : destroy();
    };
  }, [store, opts]);
  return store;
};

var useMediaController = function useMediaController(selector) {
  var mediaController = React.useContext(MediaControllerContext);
  return useStore(mediaController, selector);
};

var useTheme = function useTheme(theme) {
  return useTheme$1(ThemeContext, createTheme, theme);
};

export { MediaControllerProvider as M, ThemeContext as T, useTheme as a, MediaControllerContext as b, useMediaController as u };
